export default "__VITE_ASSET__nGwe1Agr__"